import React from 'react';
import { View } from 'react-native';

const MenuItem = () => {
  return (
    <View>

    </View>
  )
}

const Menu = () => {
  return (
    <View>

    </View>
  )
}

export { MenuItem }
export default Menu;
